import { render, staticRenderFns } from "./PreviousTreatmentMedicine.vue?vue&type=template&id=763e5ed6&scoped=true&"
import script from "./PreviousTreatmentMedicine.vue?vue&type=script&lang=js&"
export * from "./PreviousTreatmentMedicine.vue?vue&type=script&lang=js&"
import style0 from "./PreviousTreatmentMedicine.vue?vue&type=style&index=0&id=763e5ed6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763e5ed6",
  null
  
)

export default component.exports